import { HttpClient } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { ThemeService } from 'vhobjects-service/src/services';
import { FunctionService} from 'vhobjects-service/src/services';

@Component({
  selector: 'atw-customize-newField-config',
  templateUrl: './customize-newField-config.component.html',
  styleUrls: ['./customize-newField-config.component.scss']
})
export class AtwCustomizeNewFieldConfig {
  @Input() objectChoosing: any;
  @Input() device: any
  @Input() class: any;
  @Input() config: any;
  @Input() type: any;
  @Input() staticdata: any;
  isViewAll: boolean = false;
  currentViewAll: any = {};
  newFields = [];
  lookupGroupArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  currentField: any;
  template: any;


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public functionService: FunctionService,
    public themeService: ThemeService,
  ) {
  }

  ngOnInit(): void {
    this.getNewFileds();
    forkJoin([
      this.http.get('assets/data/objects_sample/basic/customize-newField/customize-newField-template.json'),
    ]).subscribe(([template]: any) => {
      this.template = template
    })
  }

  getNewFileds() {
    this.vhQueryAutoWeb.getNewFields_byFields({ id_main_sector: { $eq: this.staticdata.id_main_sector } })
      .then((newfields: any) => {
        this.newFields = newfields;

        if (this.staticdata.field_custom) {
          this.currentField = this.newFields.find((field) => field.field_custom == this.staticdata.field_custom);
        }
      });
  }

  /**
 * Hàm này dùng để mở rộng phần cấu hình.
 * @param field_text : trả về phần tử được chọn của mảng style_field
*/
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }


  onChangeFieldCustom(selectedValue: any) {
    this.currentField = this.newFields.find((field) => field.field_custom == selectedValue);
    const { field_input_location, field_input_type, field_display_type } = this.currentField

    let dataUpdate: any = {}
    if (field_input_location == 'user') {
      if (field_input_type.includes('select')) {
        dataUpdate = {
          resize_group: 'input',
          resize_field: 'select__boundary'
        }
      }

      if (field_input_type.includes('input') || field_input_type == 'textarea') {
        dataUpdate = {
          resize_group: 'input',
          resize_field: 'input__boundary'
        }
      }

      if (field_display_type == 'text' && field_input_type == 'ckeditor') {
        dataUpdate = {
          resize_group: 'image',
          resize_field: 'text'
        }
      }
      if (field_display_type == 'radio') {
        // dùng group image vì group input phải có [id]="'boundary'+data._id"
        dataUpdate = {
          resize_group: 'image',
          resize_field: 'radio'
        }
      }
    } else if (field_input_location == 'admin') {
      if (field_display_type.includes('select')) {
        dataUpdate = {
          resize_group: 'input',
          resize_field: 'select__boundary'
        }
      }

      if (field_display_type == 'radio') {
        // dùng group image vì group input phải có [id]="'boundary'+data._id"
        dataUpdate = {
          resize_group: 'image',
          resize_field: 'radio'
        }
      }

      if (field_display_type == 'text') {
        dataUpdate = {
          resize_group: 'text',
          resize_field: 'text'
        }

        if(field_input_type == 'ckeditor') {
          dataUpdate.resize_group = 'image'
        }
      }

      if (field_display_type == 'image') {
        dataUpdate = {
          resize_group: 'image',
          resize_field: 'image'
        }
      }
    }

    dataUpdate = {
      ...dataUpdate,
      desktop_class: {
        ...this.template[dataUpdate.resize_field]
      },
      tablet_landscape_class: {
        ...this.template[dataUpdate.resize_field]
      },
      tablet_portrait_class: {
        ...this.template[dataUpdate.resize_field]
      },
      mobile_landscape_class: {
        ...this.template[dataUpdate.resize_field]
      },
      mobile_portrait_class: {
        ...this.template[dataUpdate.resize_field]
      },
      staticdata: this.staticdata
    }

    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, dataUpdate)
  }






  changeLookupGroup(event) {
    this.staticdata.lookup_group = event;
    this.updateStaticData();
  }


  /**
 * Cập nhật staticdata vào database.
 */
  updateStaticData() {
    // Gọi hàm truy vấn cơ sở dữ liệu ở đây
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
      });
  }
}

